(function () {
  'use strict';

  var STYLE_ID = 'sr-recommendations-style';
  var DROPDOWN_ID = 'sr-recommendations-dropdown';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + DROPDOWN_ID + ' {',
      '  position: absolute;',
      '  top: 100%;',
      '  left: 0;',
      '  right: 0;',
      '  background: #fff;',
      '  border: 1px solid #e1e3e5;',
      '  border-radius: 8px;',
      '  box-shadow: 0 4px 16px rgba(0,0,0,0.12);',
      '  z-index: 1000;',
      '  overflow: hidden;',
      '  margin-top: 4px;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-header {',
      '  padding: 10px 16px 6px;',
      '  font-size: 11px;',
      '  font-weight: 600;',
      '  letter-spacing: 0.06em;',
      '  text-transform: uppercase;',
      '  color: #6d7175;',
      '  border-bottom: 1px solid #f1f2f3;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-item {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 12px;',
      '  padding: 10px 16px;',
      '  text-decoration: none;',
      '  color: inherit;',
      '  transition: background 0.15s;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-item:hover {',
      '  background: #f6f6f7;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-img-wrap {',
      '  width: 44px;',
      '  height: 44px;',
      '  flex-shrink: 0;',
      '  border-radius: 6px;',
      '  overflow: hidden;',
      '  background: #f1f2f3;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-img-wrap img {',
      '  width: 100%;',
      '  height: 100%;',
      '  object-fit: cover;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-img-placeholder {',
      '  width: 24px;',
      '  height: 24px;',
      '  opacity: 0.3;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-info {',
      '  flex: 1;',
      '  min-width: 0;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-title {',
      '  font-size: 14px;',
      '  font-weight: 500;',
      '  color: #202223;',
      '  white-space: nowrap;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '}',
      '#' + DROPDOWN_ID + ' .sr-price {',
      '  font-size: 13px;',
      '  color: #6d7175;',
      '  margin-top: 2px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function formatPrice(amount, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(parseFloat(amount));
    } catch (e) {
      return amount + ' ' + (currency || '');
    }
  }

  function buildDropdown(products) {
    var existing = document.getElementById(DROPDOWN_ID);
    if (existing) existing.remove();

    if (!products || products.length === 0) return null;

    var dropdown = document.createElement('div');
    dropdown.id = DROPDOWN_ID;
    dropdown.setAttribute('role', 'listbox');
    dropdown.setAttribute('aria-label', 'Produits recommandés');

    var header = document.createElement('div');
    header.className = 'sr-header';
    header.textContent = 'Produits populaires';
    dropdown.appendChild(header);

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'sr-item';
      link.href = '/products/' + product.handle;
      link.setAttribute('role', 'option');

      var imgWrap = document.createElement('div');
      imgWrap.className = 'sr-img-wrap';

      if (product.featured_image && product.featured_image.url) {
        var img = document.createElement('img');
        img.src = product.featured_image.url;
        img.alt = product.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      } else {
        var placeholder = document.createElement('img');
        placeholder.className = 'sr-img-placeholder';
        placeholder.src = 'data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 20 20%22%3E%3Cpath fill%3D%22%23000%22 d%3D%22M2 2h16v16H2V2zm1 1v14h14V3H3zm3 3h8v2H6V6zm0 4h8v2H6v-2z%22%2F%3E%3C%2Fsvg%3E';
        placeholder.alt = '';
        imgWrap.appendChild(placeholder);
      }

      var info = document.createElement('div');
      info.className = 'sr-info';

      var title = document.createElement('div');
      title.className = 'sr-title';
      title.textContent = product.title;

      var price = document.createElement('div');
      price.className = 'sr-price';
      if (product.price_min !== undefined) {
        price.textContent = formatPrice(product.price_min / 100, product.price_max_variant && product.price_max_variant.currency_code);
      }

      info.appendChild(title);
      info.appendChild(price);
      link.appendChild(imgWrap);
      link.appendChild(info);
      dropdown.appendChild(link);
    });

    return dropdown;
  }

  function hideDropdown() {
    var el = document.getElementById(DROPDOWN_ID);
    if (el) el.remove();
  }

  function init() {
    var predictiveSearch = document.querySelector('predictive-search');
    if (!predictiveSearch) return;

    var input = predictiveSearch.querySelector('input[type="search"], input[name="q"]');
    var container = predictiveSearch.querySelector('[data-predictive-search]');
    if (!input || !container) return;

    injectStyles();

    var fetchController = null;
    var cachedProducts = null;

    function showRecommendations() {
      if (input.value.trim().length > 0) return;

      if (cachedProducts !== null) {
        var dropdown = buildDropdown(cachedProducts);
        if (dropdown) {
          container.style.position = 'relative';
          container.appendChild(dropdown);
        }
        return;
      }

      if (fetchController) fetchController.abort();
      fetchController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url = '/search/suggest.json?q=*&resources[type]=product&resources[limit]=6';
      var fetchOptions = fetchController ? { signal: fetchController.signal } : {};

      fetch(url, fetchOptions)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          cachedProducts = products;
          if (input.value.trim().length === 0) {
            var dropdown = buildDropdown(products);
            if (dropdown) {
              container.style.position = 'relative';
              container.appendChild(dropdown);
            }
          }
        })
        .catch(function () {
          // Silently ignore fetch errors (e.g. aborted)
        });
    }

    input.addEventListener('focus', function () {
      if (input.value.trim().length === 0) {
        showRecommendations();
      }
    });

    input.addEventListener('input', function () {
      if (input.value.trim().length > 0) {
        hideDropdown();
      } else {
        showRecommendations();
      }
    });

    input.addEventListener('blur', function () {
      setTimeout(hideDropdown, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();